export default theme => ({
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: 'white',
    boxShadow: theme.shadows[5],
    p: 4,
    padding: theme.spacing(4)
  },
  typography: {
    color: `${theme.palette.text.primary}`,
    flexGrow: 1
  }
})
